import { useState } from 'react';
import { useData } from '../../data/hooks';
import { Banner } from '../../ui/Banner';

const KEY = 'tahi.storageBannerDismissed';

export function StorageBanner() {
  const { mode } = useData();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  });
  if (mode !== 'memory' || dismissed) return null;
  return (
    <Banner
      onDismiss={() => {
        setDismissed(true);
        try {
          sessionStorage.setItem(KEY, '1');
        } catch {
          // fine: it shows again next launch
        }
      }}
    >
      This browser can't keep Tahi's data on the device, so Tahi loads it from your account each
      time you open it. Changes made while offline are lost if you close the app before it syncs.
    </Banner>
  );
}
